var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCantiere(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8545 8.22857H26.8205V16.3019H21.5418V23.9288H34.6027V16.2825H29.324V8.22857H36.097L12.2652 0L0 8.22857H6.9283L4.1531 33.4771H0V36H3.8814H20.9014H36.097V33.4771H20.6102L17.8545 8.22857ZM32.0798 21.3865H24.0647V18.8054H32.0798V21.3865ZM8.83019 14.0119H15.9526L16.2825 16.9617H8.51968L8.83019 14.0119ZM8.22857 19.4846H16.5542L16.8841 22.4345H7.89865L8.22857 19.4846ZM17.1558 24.9574L17.4857 27.9073H7.29704L7.62696 24.9574H17.1558ZM12.634 2.79461L21.0566 5.70566H17.5828H8.3062L12.634 2.79461ZM15.3121 8.22857L15.6615 11.4889H9.10189L9.45121 8.22857H15.3121ZM6.69542 33.4771L7.02534 30.4302H17.738L18.0679 33.4771H6.69542Z",
    fill: "#08A2AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCantiere);
export default __webpack_public_path__ + "static/media/ico-cantiere.c83be767.svg";
export { ForwardRef as ReactComponent };